import { useContext } from "react";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

const TurnosSinSeleccion = () => {
  const { pasoDispatch } = useContext(AutocheckContext);
  const handleClickOne = () => {
    setPaso("UbicacionActual")(pasoDispatch);
  };
  const handleClickTwo = () => {
    setPaso("TurnosDelDia")(pasoDispatch);
  };

  return (
    <ModalAutoT
      title={`Recepción`}
      desc={`Notamos que dejo un turno sin seleccionar. ¿Desea avanzar y recepcionar los turnos seleccionados?`}
      textBtnOne={"SI"}
      textBtnTwo={"VOLVER"}
      handleChange={{ btnOne: handleClickOne, btnTwo: handleClickTwo }}
    />
  );
};

export default TurnosSinSeleccion;
